// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3gzy-","footer":"ChangeClinic_footer__1CXDt"};